import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import classnames from 'classnames'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'

import OptionsButton from './OptionsButton'
import NameCell from './NameCell'
import NumberInput from './NumberInput'

import info from 'shared/src/resource/info'
import numberUtils from 'shared/src/utils/number'
import settings from 'shared/src/settings'

const useStyles = makeStyles(theme => ({
  root: {
    
  },
  smallCell: {
    width: '40px',
  },
  buttonCell: {
    textAlign: 'left',
    width:  ['20px', '!important'],
  },
  nameCell: {
    //width: '30%',
  },
  smallNumberCell: {
    width: '80px',
    paddingLeft: ['20px', '!important'],
  },
  numberCell: {
    width: '120px',
    paddingLeft: ['20px', '!important'],
  },
  unitCell: {
    width: '60px',
    paddingLeft: ['20px', '!important'],
  },
  wideNumberCell: {
    width: '140px',
    paddingLeft: ['20px', '!important'],
  },
  optionsCell: {
    width: '60px',
    paddingLeft: ['20px', '!important'],
  },
  table: {
    width: '100%',
    '& td,th': {
      padding: '0px',
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5),
      verticalAlign: 'top',
    },
  },
  linkRow: {
    backgroundColor: '#f5f5f5',
    '& td': {
      borderBottom: '1px solid rgba(200, 200, 200, 1)'
    }
  },
  highlightTotalRow: {
    backgroundColor: '#f0f0f0',
    height: '45px',
    '& td': {
      borderBottom: '1px solid rgba(200, 200, 200, 1)'
    }
  },
  highlightMarkupRow: {
    backgroundColor: '#f5f5f5',
    height: '45px',
    '& td': {
      borderBottom: '1px solid rgba(200, 200, 200, 1)'
    }
  },
  boldText: {
    fontWeight: 'bold',
  },
  nonInputPadding: {
    paddingRight: '16px',
    fontSize: '1.1em'
  },
  textCell: {
    paddingTop: '8px',
    whiteSpace: 'nowrap',
  },
  leftBorderCell: {
    borderLeft: '1px solid #e5e5e5',
  },
  rightPaddingCell: {
    width: '140px !important',
    paddingRight: `20px !important`,
  },
  paddingTitleCell: {
    paddingRight: `20px !important`,
  }
}))

const QuoteTable = ({
  rows,
  totals,
  markups,
  edits,
  inputs,
  expanded,
  inputMarkups,
  editName,
  inputVat,
  currency,
  sortMode,
  readOnly,
  clientView,
  noTotals,
  onSetInput,
  onSetEdit,
  onChange,
  onExpand,
  onAddItem,
  onUpdateEditName,
  onCommitEditName,
  onResetEditName,
  onSwapLinkChildren,
  onSwapFolderChildren,
  onSetQuoteInput,
  onSetQuoteEdit,
  onOpenTaskWindow,
  onOpenDeleteWindow,
  onExpandChildren,
  onContractChildren,
}) => {
  const classes = useStyles()

  const getRowOptions = (item) => {
    if(sortMode) return null
    if(readOnly) return null
    return (
      <OptionsButton
        showAll
        item={ item }
        readOnly={ readOnly }
        sortMode={ sortMode }
        onAddItem={ onAddItem }
        onOpenTaskWindow={ onOpenTaskWindow }
        onOpenDeleteWindow={ onOpenDeleteWindow }
        onExpandChildren={ onExpandChildren }
        onContractChildren={ onContractChildren }
      />
    )
  }

  const getFieldText = ({
    isInput,
    isBold,
    isMoney,
    value,
    noPadding,
  }) => {

    const classNames = [
      isInput ? classes.nonInputPadding : null,
      isBold ? classes.boldText : null,
      noPadding ? null : classes.textCell,
    ].filter(c => c)

    return (
      <div className={ classNames.join(' ') }>
        { isMoney && `${currency} `}{ isMoney ? numberUtils.twoDp(value, true) : value }
      </div>
    )
  }

  const getFieldCell = ({
    row,
    field,
    calculatedValue,
    isMoney,
  }) => {
    const {
      item,
    } = row
    if(item.type == 'folder') return null
    const inputs = item.inputs || {}
    const edits = item.edits || {}
    let value = null
    if(edits[field]) {
      value = inputs[field]
    }
    else {
      value = inputs[field] || calculatedValue
    }

    const hasInput = inputs[field] ? true : false

    let highlight = false

    // only highlight an amount field if it's an override
    if(field == 'amount') {
      highlight = typeof(row.linkIndex) == 'number' ?
        hasInput :
        false
    }
    else {
      highlight = hasInput
    }

    if(readOnly) {
      return getFieldText({
        isInput: true,
        isBold: highlight,
        isMoney,
        value,
      })
    }

    return (
      <NumberInput
        value={ value || '' }
        highlight={ highlight }
        onCommit={ onChange }
        onChange={ (value) => {
          onSetInput({
            id: item.id,
            linkIndex: row.linkIndex,
            field,
            value
          })
        }}
        onFocus={ () => {
          if(!inputs[field]) {
            onSetInput({
              id: item.id,
              linkIndex: row.linkIndex,
              field,
              value: calculatedValue,
            })
          }
          onSetEdit({
            id: item.id,
            linkIndex: row.linkIndex,
            field,
            value: true,
          })
        }}
        onBlur={ () => {
          onSetEdit({
            id: item.id,
            linkIndex: row.linkIndex,
            field,
            value: false,
          })
        }}
      />
    )
  }


  const getQuoteInputCell = ({
    fieldName,
    inputField,
  }) => {

    //const fieldName = `markup.${field}`
    //const markupField = inputMarkups[field]

    let value = null
    if(edits[fieldName]) {
      value = inputs[fieldName]
    }
    else {
      value = inputs[fieldName] || inputField.value || 0
    }

    if(readOnly) {
      return getFieldText({
        isInput: true,
        isBold: false,
        value,
      })
    }

    return (
      <NumberInput
        value={ value }
        highlight={ inputField.overriden }
        onChange={ (value) => {
          onSetQuoteInput({
            field: fieldName,
            value
          })
        }}
        onFocus={ () => {
          if(!inputs[fieldName]) {
            onSetQuoteInput({
              field: fieldName,
              value,
            })
          }
          onSetQuoteEdit({
            field: fieldName,
            value: true,
          })
        }}
        onBlur={ () => {
          onSetQuoteEdit({
            field: fieldName,
            value: false,
          })
        }}
        onCommit={ onChange }
      />
    )
  }

  const getAdjustmentCell = (row) => {
    const {
      item,
      basePrice,
      priceMode,
    } = row
    if(item.type == 'folder') return null
    if(item.resource.type == 'template') return null
    if(priceMode == 'priceBased' && basePrice) return null
    const inputs = item.inputs || {}
    const value = inputs.adjustment || ''

    if(readOnly) {
      return getFieldText({
        isInput: true,
        isBold: false,
        value,
      })
    }

    return (
      <NumberInput
        value={ value }
        onChange={ (value) => {
          onSetInput({
            id: item.id,
            linkIndex: row.linkIndex,
            field: 'adjustment',
            value
          })
        }}
        onCommit={ onChange }
      />
    )
  }

  const getAmountCell = (row) => {
    const {
      basePrice,
      price,
      priceMode,
      item,
    } = row

    if(item.type == 'folder') return null
    if(priceMode == 'priceBased' && basePrice) {
      return getFieldText({
        isInput: true,
        value: basePrice.amount,
      })
    }
    else {
      return getFieldCell({
        row,
        field: 'amount',
        calculatedValue: numberUtils.twoDp(price.amount)
      })
    }
  }

  const getUnitCell = (row) => {
    const {
      item,
      basePrice,
      price,
      priceMode,
    } = row
    if(item.type == 'folder') return null

    const value = priceMode == 'priceBased' && basePrice ?
      basePrice.unit :
      price.unit

    return getFieldText({
      value,
    })
    
  }

  const getPriceCell = (row) => {
    const {
      item,     
      price,
    } = row
    if(item.type == 'folder') return null
    if(item.resource.type == 'template') return null
    return getFieldCell({
      row,
      field: 'price',
      isMoney: true,
      calculatedValue: numberUtils.twoDp(price.base.unitPrice || price.base.price),
      readOnlyValue: (value) => `${value}`,
    })
  }

  const getTotalCell = (row) => {
    const {
      item,
      price,
      expanded,
      hasChildren,
    } = row
    if(expanded && hasChildren) return null
    return getFieldText({
      isBold: item.type == 'folder',
      isMoney: true,
      value: price.price,
    })
  }

  const getQuoteEditRow = ({
    title,
    fieldName,
    inputField,
    price,
    total,
  }) => {
    return (
      <TableRow key={ fieldName } className={ classes.highlightMarkupRow }>
        <TableCell align="right" className={ classes.paddingTitleCell }>
          {
            getFieldText({
              value: title,
            })
          }
        </TableCell>
        {
          !clientView ? (
            <TableCell align="right" className={ classnames(classes.smallNumberCell, classes.leftBorderCell) }>
              {
                getQuoteInputCell({
                  fieldName,
                  inputField,
                })
              }
            </TableCell>
          ) : (
            <TableCell align="right" className={ classnames(classes.smallNumberCell, classes.leftBorderCell) }>
              {
                getFieldText({
                  isInput: true,
                  value: inputField.value,
                })
              }
            </TableCell>
          )
        }
        <TableCell colSpan={ clientView ? 1 : 2 } align="right">

        </TableCell>
        <TableCell align="right" className={ classes.numberCell }>
          {
            getFieldText({
              isInput: true,
              isMoney: true,
              value: price,
            })
          }
        </TableCell>
        <TableCell align="right" className={ classnames(classes.wideNumberCell, classes.leftBorderCell) }>
          {
            getFieldText({
              isMoney: true,
              value: total,
            })
          }
        </TableCell>
        {
          !clientView && (
            <TableCell className={ classes.optionsCell }>
      
            </TableCell>
          )
        }
      </TableRow>
    )
  }

  const getTotalRow = ({
    title,
    value,
  }) => {
    return (
      <TableRow className={ classes.highlightTotalRow }>
        <TableCell align="right" className={ classes.paddingTitleCell }>
          {
            getFieldText({
              isBold: true,
              value: title,
            })
          }
        </TableCell>
        <TableCell colSpan={ 2 } align="right" className={ classes.leftBorderCell }>

        </TableCell>
        <TableCell colSpan={ clientView ? 1 : 2 }></TableCell>
        <TableCell align="right" className={ classnames(classes.wideNumberCell, classes.leftBorderCell) }>
          {
            getFieldText({
              isBold: true,
              isMoney: true,
              value: value,
            })
          }
        </TableCell>
        {
          !clientView && (
            <TableCell className={ classes.optionsCell }>
      
            </TableCell>
          )
        }
      </TableRow>
    )
  }

  // how to print out quote values in a way to compare to import values in the old system
  // console.log(rows.map(row => {

  //   let name = row.item.resource.name

  //   if(name.length > 42) {
  //     name = name.substring(0, 42)
  //   }
  //   else {
  //     name = name.padEnd(42, ' ')
  //   }

  //   return `${name} £${numberUtils.twoDp(row.price.price, true, true)}`
  // }).join("\n"))

  return (
    <div className={ classes.root }>
      <Table
        className={ classes.table }
        size="small"
      >
        <TableHead>
          <TableRow>
            <TableCell className={ classes.nameCell }>
              Name    
            </TableCell>
            <TableCell align="right" className={ classes.numberCell }>
              {
                getFieldText({
                  isInput: true,
                  noPadding: true,
                  value: 'Amount'
                })
              }    
            </TableCell>
            <TableCell align="right">
              Unit    
            </TableCell>
            {
              !clientView && (
                <TableCell align="right" className={ classes.smallNumberCell }>
                  {
                    getFieldText({
                      isInput: true,
                      noPadding: true,
                      value: '+/-'
                    })
                  } 
                </TableCell>
              )
            }
            <TableCell align="right" className={ classes.numberCell }>
              {
                getFieldText({
                  isInput: true,
                  noPadding: true,
                  value: 'Price'
                })
              }     
            </TableCell>
            <TableCell align="right" className={ classes.numberCell }>
              Total    
            </TableCell>
            {
              !clientView && (
                <TableCell>
                      
                </TableCell>
              )
            }
          </TableRow>
        </TableHead>
        <TableBody>
          {
            rows.map((row, i) => {

              const {
                item,
                isLink,
              } = row

              return (
                <TableRow key={ i } className={ isLink ? classes.linkRow : '' }>
                  <TableCell>
                    <NameCell
                      row={ row }
                      index={ i }
                      readOnly={ readOnly }
                      sortMode={ sortMode }
                      editName={ editName }
                      expanded={ expanded }
                      onChange={ onChange }
                      onExpand={ onExpand }
                      onUpdateEditName={ onUpdateEditName }
                      onCommitEditName={ onCommitEditName }
                      onResetEditName={ onResetEditName }
                      onSwapLinkChildren={ onSwapLinkChildren }
                      onSwapFolderChildren={ onSwapFolderChildren }
                    />
                  </TableCell>
                  <TableCell align="right" className={ classnames(classes.numberCell, classes.leftBorderCell) }>
                    { getAmountCell(row) }
                  </TableCell>
                  <TableCell align="right" className={ classes.unitCell }>
                    { getUnitCell(row) }
                  </TableCell>
                  {
                    !clientView && (
                      <TableCell align="right" className={ classes.smallNumberCell }>
                        { getAdjustmentCell(row) }
                      </TableCell>
                    )
                  }
                  <TableCell align="right" className={ classnames({
                    [classes.numberCell]: true,
                    [classes.rightPaddingCell]: clientView ? false : true,
                  }) }>
                    { getPriceCell(row) }
                  </TableCell>
                  <TableCell align="right" className={ classnames(classes.wideNumberCell, classes.leftBorderCell) }>
                    { getTotalCell(row) }
                  </TableCell>
                  {
                    !clientView && (
                      <TableCell className={ classes.optionsCell }>
                        { getRowOptions(item) }
                      </TableCell>
                    )
                  }
                </TableRow>
              )
            })
          }

          {
            // Costs Total
            !readOnly && !noTotals && getTotalRow({
              title: 'Costs Total',
              value: totals.costsTotal,
            })
          }

          {
            // Loop over markups
            !readOnly && !noTotals && settings.markupOrder.map((field, i) => {

              const markup = markups[field]

              return getQuoteEditRow({
                title: `% ${info.markupTitle(field)} Markup`,
                fieldName: `markup.${field}`,
                inputField: inputMarkups[field],
                price: markup.price,
                total: markup.total,
              })
              
            })
          }

          {
            // Markup Total
            !readOnly && !noTotals && getTotalRow({
              title: 'Markup Total',
              value: totals.markupTotal,
            })
          }

          {
            // Sub Total
            !noTotals && getTotalRow({
              title: 'Sub Total',
              value: totals.subTotal,
            })
          }

          {
            // VAT %
            !noTotals && getQuoteEditRow({
              title: `% VAT`,
              fieldName: `vat`,
              inputField: inputVat,
              price: totals.subTotal,
              total: totals.vatAmount,
            })
          }

          {
            // Grand Total
            !noTotals && getTotalRow({
              title: 'Grand Total',
              value: totals.grandTotal,
            })
          }
        
        </TableBody>
      </Table>
    </div>
  )
}

export default QuoteTable

